import React from 'react'
import { workSteps } from '../Data/ComponentsData/componentsdata'
import { Col, Container, Row } from 'reactstrap'

const Work = () => {
  return (
    <section className="work" id="work">
        <Container>
          <Row>
            <Col md="8" className="offset-md-2 text-center">
              <div className="section-title">
                <h2>How Chatloop Works</h2>
                <img src="assets/images/title-line.png" alt="white-line" className="img-fluid" />
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem autem voluptatem obcaecati! ipsum dolor sit Rem autem voluptatem obcaecati</p>
              </div>
            </Col>
          </Row>
          <Row>
            {workSteps.map((step, index) => (
              <Col lg="4" className="text-center" key={index}>
                <div className="process-box">
                  <img src={step.imgSrc} alt="" />
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                  <img src={step.imgSrc} alt="" className="bg-icon" />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
  )
}

export default Work